module.exports = __webpack_public_path__ + "static/media/logo.77f8732a.svg";